// removed by extract-text-webpack-plugin
module.exports = {"filter":"_1pVg25ggYkUwS37DDhkEVr","filter-container":"_1Y6emu4TxDR7ROX4dntjJD","loading":"_37YCJ1DSu8RRVQ7po8MPIy","companies":"_1w0YHtbkvcNk8V7cIxKaVn","contacts-list":"_1muEANVE9EoHHB7hL9OfyD","load-more-button":"_3hWOmPF6pnXQxaQhLxvppT","error":"_3kp4HGVrhEptEx58n1ezRr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ContactsList/ContactsList.module.scss
// module id = 743
// module chunks = 0